import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'src/component/ds/utils';

const badgeVariants = cva(
  [
    'ds-inline-flex ds-items-center ds-gap-1 ds-h-6 ds-px-2 ds-py-1',
    'ds-rounded ds-text-xs ds-font-medium ds-whitespace-nowrap',
    'focus-visible:ds-outline-none focus-visible:ds-shadow-chemelex-focus',
    '[&_svg]:ds-h-3 [&_svg]:ds-w-3 [&_svg]:ds-shrink-0'
  ],
  {
    variants: {
      variant: {
        primary: 'ds-bg-primary ds-text-primary-foreground',
        secondary: 'ds-bg-secondary ds-text-secondary-foreground',
        outline: 'ds-border ds-border-border ds-bg-transparent ds-text-foreground',
        ghost: 'ds-bg-transparent ds-text-foreground',
        destructive: 'ds-bg-destructive ds-text-destructive-foreground'
      }
    },
    defaultVariants: { variant: 'primary' }
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
  VariantProps<typeof badgeVariants> {}

/* Forwards its ref so it can sit under a Radix `asChild` trigger, e.g. TooltipTrigger. */
const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(({ className, variant, ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
));
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
